export const pagesList = () => {
	let iframe = document.getElementById('pagesListIframe');
	if (!iframe) {
		return
	}

	let links = document.querySelectorAll('.js-pages-list a');

	try  {
		links.forEach(link => {
			link.addEventListener('mouseenter', () => {
				iframe.setAttribute('src', link.getAttribute('href'));
			})
		})
	} catch (e) {}
}